<div class="grid-container">
<div class="content content-with-elevation">
  <div class="grid-y" *ngIf="!emailSent">

    <p>Please provide your username. An email will be sent to you to reset your password.</p>
    <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()" novalidate>
      <common-alerts [error]="errorMessages"></common-alerts>
      <div class="grid-y">
        <div class="grid-x">
          <div class="cell large-2 medium-4 small-12">
            <label class="label-center">Username</label>
          </div>
          <div class="large-4 medium-8 small-12">
            <input formControlName="userName" placeholder="Username"
                   class="input-group-custom" required>
            <div class="input-field-error" *ngIf="resetPasswordForm.get('userName').errors?.invalidFormat">
              Use your RZMS username, not email address
            </div>
          </div>
        </div>
        <div class="grid-x" style="padding-top: 8px">
          <div class="cell large-2 medium-4 small-12">
          </div>
          <div class="large-4 medium-8 small-12">
            <div class="button-placement-right">

            <button class="iana-button" type="submit"
                    [disabled]="!resetPasswordForm.valid">Proceed
            </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="grid-y" *ngIf="emailSent">
    <p>Please complete the instructions in the email we sent to reset your password.</p>
    <p>Close this page, or go back to the <a routerLink="/home">login</a> page.</p>
  </div>
</div>
</div>
